import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";

const { carbon, bluegrey } = colorsPalettes;

interface IGroupDropdownMenuItemProps {
    id: string;
    iconName?: IconName;
    title: string;
    description: string;
    isDisabled?: boolean;
    className?: string;
    onClick?: () => void;
    isSelected?: boolean;
}

const GroupContainer = styled.div<{ disabled?: boolean; isSelected?: boolean }>`
    padding: 11px 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    background-color: ${carbon[0]};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
    ${({ isSelected }) => isSelected && `background-color: ${bluegrey[100]};`}
    &:hover {
        background-color: ${carbon[25]};
    }
`;

const Icon = styled(SWReactIcons).attrs((props) => ({ size: "sm" }))`
    margin-right: 7px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 259px;
    gap: 6px;
`;

const Title = styled.div<{ color: string }>`
    ${({ color = carbon[500] }) => setFontVariant("input2", color)}
`;

const Descritpion = styled.div<{ color: string }>`
    ${({ color = carbon[300] }) => setFontVariant("listItem3", color)}
`;
const DISABLED_COLOR = carbon[100];
export const GroupDropdownMenuItem: FC<IGroupDropdownMenuItemProps> = (props) => {
    const { id, className, onClick, isDisabled, iconName, title, description, isSelected = false } = props;

    return (
        <GroupContainer
            id={id}
            className={className}
            onClick={onClick}
            disabled={isDisabled}
            isSelected={isSelected}
        >
            {iconName ? <Icon iconName={iconName} /> : null}
            <Content>
                <Title color={isDisabled ? DISABLED_COLOR : undefined}>{title}</Title>
                <Descritpion color={isDisabled ? DISABLED_COLOR : undefined}>{description}</Descritpion>
            </Content>
        </GroupContainer>
    );
};
